"use client";
import {
  scroll_shadow_default
} from "./chunk-4EXC76WE.mjs";
import {
  useScrollShadow
} from "./chunk-XKHEX3UH.mjs";
export {
  scroll_shadow_default as ScrollShadow,
  useScrollShadow
};
